// eslint-disable-next-line import/prefer-default-export
export const placeholders = {
  inEuro: "in Euro",
  inTEuro: "in TEuro p.a.",
  pleaseSelect: "Bitte wählen",
  pleaseFillIn: "Bitte eingeben",
  inPercentage: "in Prozent",
  inSquareMeters: "in Quadratmetern",
  inYears: "in Jahren",
  inMonths: "in Monaten",
  password: "Geben Sie Ihr Passwort an"
};
